import React from "react";
import I18n from "i18n-js";

import teamGreenIcon from "../assets/images/team-green.svg";
import teamTealIcon from "../assets/images/team-teal.svg";
import teamDkBlueIcon from "../assets/images/team-dk-blue.svg";
import teamBlueIcon from "../assets/images/team-blue.svg";
import teamYellowIcon from "../assets/images/team-yellow.svg";
import teamGreyIcon from "../assets/images/team-grey.svg";

const MaxMemberCount = ({ maxMembers, color }) => {

  const getColorIcon = (color = "dkblue") => {
    let colorMap = {
      green: teamGreenIcon,
      teal: teamTealIcon,
      dkblue: teamDkBlueIcon,
      blue: teamBlueIcon,
      yellow: teamYellowIcon,
      grey: teamGreyIcon,
    };
    return colorMap[color];
  }

  if (!maxMembers) { return null; }

  return (
    <div className="member-counter">
      <img src={getColorIcon(color)} />
      <div>
        {I18n.t("user.max_members", { members: maxMembers })}
      </div>
    </div>
  );
}

export default MaxMemberCount;

